import React from 'react'
import './Hero.sass'
import { withRouter } from 'react-router-dom'

import Icon from '../../ui/Icon/Icon'

import Button from '../../ui/Button/Button'
import heroBg from './assets/bg.jpg'

function Hero({ ...router }) {
  const data = [
    { icon: 'money-bill', title: 'Проживание от 500 руб./cутки' },
    { icon: 'paw-alt', title: 'Можно с животными, это бесплатно' },
    { icon: 'lock', title: 'Бесплатная камера хранения' },
    { icon: 'shield-check', title: 'Работаем с физ и юр. лицами' },
  ]

  return (
    <>
      <div id="home" className="Site-Hero">
        <div
          className="HeroBg"
          style={{ backgroundImage: `url(${heroBg})` }}
        ></div>
        <div className="DefaultContainer">
          <div className="Offer">
            <h1 className="Title">
              Общежитие <span className="accent">ЗАПОЛЯРЬЕ</span>
            </h1>
            <p className="Description">Спокойный отдых вблизи центра города</p>
            <div className="Benefits">
              {data.map((d) => (
                <Benefit {...d} />
              ))}
            </div>
            <div className="Buttons">
              <Button
                theme="primary"
                title="Забронировать номер"
                type="button"
                icon="calendar-alt"
                iconWeight="solid"
                onClick={() => (window.location.href = '/booking')}
                size={48}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="Booking-Container">
        <div className="DefaultContainer" id="block-search">
          <div id="tl-search-form" class="tl-container">
            <noindex>
              <a
                href="https://www.travelline.ru/products/tl-hotel/"
                rel="nofollow noreferrer"
                target="_blank"
              >
                TravelLine
              </a>
            </noindex>
          </div>
        </div>
      </div>
    </>
  )
}

function Benefit({ icon, title }) {
  return (
    <div className="Benefit">
      <div className="Icon-Benefit">
        <Icon name={icon} />
      </div>
      <span>{title}</span>
    </div>
  )
}

export default withRouter(Hero)
